import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import 'amfe-flexible'
import './assets/css/style.css'
import Vant from 'vant'
import { Tabbar, TabbarItem } from 'vant';
import DrawerLayout from 'vue-drawer-layout'

Vue.use(DrawerLayout)
Vue.use(Vant)
Vue.use(ElementUI)
Vue.config.productionTip = false


new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})



// WEBPACK FOOTER //
// ./src/main.js